import AuthorizationWrapper, {
  authFnForMaintenancePages,
  authFnAllowOnlyAdminImplementationManager,
} from '@product-framework/components/AuthorizationWrapper';
import { FORM_ACTION, getRoutes } from '@ui-framework/index';
import FlowDefinitionList from './pages/list/index';
import FlowDefinitionUpsert from './pages/upsert/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import FlowDefinitionsListStore from './store/list';
import FlowDefinitionFormStore from './store';

const FormStoreClass = FlowDefinitionFormStore;

const Pages = ProtectedRoute => ({
  FlowDefinitionEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
      Component={FlowDefinitionUpsert}
      componentProps={{ action: FORM_ACTION.EDIT }}
    />
  ),
  FlowDefinitionCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlyAdminImplementationManager],
      }}
      Component={FlowDefinitionUpsert}
      componentProps={{ action: FORM_ACTION.CREATE }}
    />
  ),
  FlowDefinitionList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={FlowDefinitionList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnForMaintenancePages],
      }}
      componentProps={{ action: FORM_ACTION.LIST }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

/**
 * Flow Definitions UI stores (registered on rootStore.uiState).
 * - flowDefinitionsListStore: list state (pagination, filters, sorting); used with storeName 'FlowDefinitionList'
 *   in store.domain.list.get/set/reset() by list/search forms. Persists as 'flowDefinitionsListStore'.
 * - flowDefinitionFormStore: form state for create/edit.
 */
const stores = rootStore => [
  {
    flowDefinitionsListStore: new FlowDefinitionsListStore(rootStore),
    flowDefinitionFormStore: new FormStoreClass(rootStore),
  },
];

export { FlowDefinitionList, routes, stores };
